import { useTranslations } from 'contexts/Translation'
import { PageWrapper, Row, Col } from '@qonsoll/react-design'
import { useParams, useHistory } from 'react-router-dom'
import { EditOutlined } from '@ant-design/icons'
import { Button } from '@qonsoll/react-design'

const BrandbookShow = (props) => {
  // [ADDITIONAL_HOOKS]
  const { t } = useTranslations()
  const history = useHistory()
  const params = useParams()

  // [COMPONENT_STATE_HOOKS]

  // [COMPUTED_PROPERTIES]
  const headingProps = {
    title: t('Brandbook show'),
    titleSize: 3,
    marginBottom: 3,
    textAlign: 'left'
  }
  const { brandbookId } = params

  // [HANDLERS]
  const handleBackButtonClick = () => history.goBack()

  return (
    <PageWrapper
      action={
        <Button
          icon={<EditOutlined />}
          onClick={() => history.push(`${brandbookId}/edit`)}>
          {t('Edit')}
        </Button>
      }
      headingProps={headingProps}>
      <Row noGutters>
        <Col>
          <> BrandbookAdvancedView</>
        </Col>
      </Row>
    </PageWrapper>
  )
}

export default BrandbookShow
